/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SystemAccounts} from '../models/SystemAccounts';

export interface GetAdminAccounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminAccountsRequest = createAction<PayloadData<void>>('GET_SYSTEM_ACCOUNTS__GET_ADMIN_ACCOUNTS__REQUEST');
export const getAdminAccountsSuccess = createAction<PayloadData<SystemAccounts>>('GET_SYSTEM_ACCOUNTS__GET_ADMIN_ACCOUNTS__SUCCESS');
export const getAdminAccountsFailure = createAction<PayloadData<Error, void, true>>('GET_SYSTEM_ACCOUNTS__GET_ADMIN_ACCOUNTS__FAILURE');

export const getAdminAccountsActions = [
    getAdminAccountsRequest,
    getAdminAccountsSuccess,
    getAdminAccountsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminAccounts = (config?: GetAdminAccounts$Config) => {
    return {
        CALL_API: {
            types: getAdminAccountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/admins`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetFreeNewsletterAccounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getFreeNewsletterAccountsRequest = createAction<PayloadData<void>>('GET_SYSTEM_ACCOUNTS__GET_FREE_NEWSLETTER_ACCOUNTS__REQUEST');
export const getFreeNewsletterAccountsSuccess = createAction<PayloadData<SystemAccounts>>('GET_SYSTEM_ACCOUNTS__GET_FREE_NEWSLETTER_ACCOUNTS__SUCCESS');
export const getFreeNewsletterAccountsFailure = createAction<PayloadData<Error, void, true>>('GET_SYSTEM_ACCOUNTS__GET_FREE_NEWSLETTER_ACCOUNTS__FAILURE');

export const getFreeNewsletterAccountsActions = [
    getFreeNewsletterAccountsRequest,
    getFreeNewsletterAccountsSuccess,
    getFreeNewsletterAccountsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getFreeNewsletterAccounts = (config?: GetFreeNewsletterAccounts$Config) => {
    return {
        CALL_API: {
            types: getFreeNewsletterAccountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/free-newsletters`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

